<div class="home-container">
  <!-- Header Hero Section -->
  <section class="hero-section">
    <div class="container">
      <div class="row align-items-center justify-content-center">
        <div class="col-xl-7 col-lg-8 text-center" @fadeInUp>
          <h1 class="font-5xl mb-4"><span class="hero-title-main">News, informazione, educazione finanziaria</span><span class="hero-title-rest">, strumenti operativi e consulenza indipendente.</span></h1>
          <p class="font-2xl text-muted font-italic mb-0">
            <span class="hero-subtitle-highlight">Tutto in un'unica <span class="hero-subtitle-strong">piattaforma</span>.</span>
          </p>
        </div>
      </div>
    </div>
  </section>

  <div class="section-padding-top" id="offerta">
    <!-- Offer Cards Component -->
    <app-offer-cards></app-offer-cards>
  </div>

  <div class="section-padding-top">
    <app-pricing-table></app-pricing-table>
  </div>
  <!-- Pricing Comparison Table -->

  <div class="section-padding-top" id="chi-siamo">
    <app-chi-siamo></app-chi-siamo>
  </div>

  <div class="section-padding-top">
    <app-instagram-feed></app-instagram-feed>
  </div>

  <div class="section-padding-top" id="contatti">
    <app-contatti></app-contatti>
  </div>
</div>
